import { Outlet } from "react-router";

export function InspectionsRoute() {
  return <Outlet />;
}
